var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.278.36a.726.726 0 0 1 1.254 0l6.178 10.547A.726.726 0 0 1 13.083 12H.727a.726.726 0 0 1-.626-1.093L6.278.359Z",
    fill: "#FF625A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.46 8.276-.144-3.842h1.167l-.145 3.842h-.877Zm.445 1.975a.643.643 0 0 1-.472-.196.647.647 0 0 1-.195-.476c0-.187.065-.345.195-.475a.643.643 0 0 1 .472-.196.64.64 0 0 1 .476.196c.13.13.195.288.195.475a.647.647 0 0 1-.195.476.64.64 0 0 1-.476.196Z",
    fill: "#fff"
  })));
};
export default SvgError;